<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="INSTALACIÓN ELÉCTRICA (I.E.)" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-1" :class="{ 'mb-4': form.voltage_responsible == 'cliente' || !form.voltage_responsible }">
              <b-col class="pl-0">
                <b-form-group class="mb-0">
                  <template #label>
                    <Label label="Voltaje disponible" :blank="form.voltage.length != 0" />
                  </template>
                  <b-checkbox-group v-model="form.voltage" stacked size="lg" class="ml-3">
                    <b-checkbox value="110">110</b-checkbox>
                    <b-checkbox value="220">220</b-checkbox>
                  </b-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <template #label>
                    <Label label="..a cargo de" :blank="form.voltage_responsible" show-reset @reset="form.voltage_responsible = null" />
                  </template>
                  <b-radio-group v-model="form.voltage_responsible" stacked size="lg" class="ml-3" @change="form.voltage_conduit = null; form.voltage_distance = null">
                    <b-radio value="Accesos">
                      Accesos
                    </b-radio>
                    <b-radio value="Cliente">
                      Cliente (std)
                    </b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="form.voltage_responsible == 'Accesos'" class="mb-4">
              <b-col cols="12" md="6" class="pl-0">
                <b-form-group label-class="configurator-label" class="w-100">
                  <template #label>
                    <Label label="Tipo de canalización" :blank="form.voltage_conduit" show-reset @reset="form.voltage_conduit = null" />
                  </template>
                  <b-select v-model="form.voltage_conduit" :options="conduitOptions">
                    <template #first>
                      <b-select-option v-show="!form.voltage_conduit" :value="null">
                        -- seleccionar --
                      </b-select-option>
                    </template>
                  </b-select>
                </b-form-group>
              </b-col>
              <b-col class="pl-0">
                <b-form-group label-class="configurator-label" class="w-100">
                  <template #label>
                    <Label label="Distancia" :blank="form.voltage_distance" />
                  </template>
                  <b-input-group append="cm" style="width: 300px;">
                    <b-form-input
                      v-model.number="form.voltage_distance"
                      type="number"
                      min="0"
                      step="1"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="flex-column" :class="{ 'mb-4': form.control_wiring_responsible == 'cliente' || !form.control_wiring_responsible }">
              <Label label="Cableado de las botoneras por" :blank="form.control_wiring_responsible" show-reset @reset="form.control_wiring_responsible = null" />
              <b-form-group>
                <b-radio-group size="lg" v-model="form.control_wiring_responsible" class="ml-4" @change="form.control_wiring_conduit = null; form.control_wiring_distance = null">
                  <b-radio value="Accesos">
                    Accesos
                  </b-radio>
                  <b-radio value="Cliente">
                    Cliente
                  </b-radio>
                </b-radio-group>
              </b-form-group>
            </b-row>

            <b-row v-if="form.control_wiring_responsible == 'Accesos'" class="mb-4">
              <b-col cols="12" md="6" class="pl-0 pl-md-1">
                <b-form-group label-class="configurator-label" class="w-100">
                  <template #label>
                    <Label label="Tipo de canalización botoneras" :blank="form.control_wiring_conduit" show-reset @reset="form.control_wiring_conduit = null" />
                  </template>
                  <b-select v-model="form.control_wiring_conduit" :options="conduitOptions">
                    <template #first>
                      <b-select-option v-show="!form.control_wiring_conduit" :value="null">
                        -- seleccionar --
                      </b-select-option>
                    </template>
                  </b-select>
                </b-form-group>
              </b-col>
              <b-col class="pl-0">
                <b-form-group label-class="configurator-label" class="w-100">
                  <template #label>
                    <Label label="Distancia" :blank="form.control_wiring_distance" />
                  </template>
                  <b-input-group append="cm" style="width: 300px;">
                    <b-form-input
                      v-model.number="form.control_wiring_distance"
                      type="number"
                      min="0"
                      step="1"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="flex-column mb-4">
              <Label label="Supresor de picos" :blank="form.surge_suppressor_responsible" show-reset @reset="form.surge_suppressor_responsible = null" />
              <b-form-group>
                <b-radio-group size="lg" v-model="form.surge_suppressor_responsible" class="ml-4">
                  <b-radio value="No, a cargo de cliente">
                    No, a cargo de cliente (std)
                  </b-radio>
                  <b-radio value="Si, a cargo de Accesos">
                    Sí, a cargo de Accesos
                  </b-radio>
                </b-radio-group>
              </b-form-group>
            </b-row>

            <b-row>
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Caja de breaker" :blank="form.breaker_box" show-reset @reset="form.breaker_box = null" />
                </template>
                <b-select v-model="form.breaker_box" :options="breakerOptions">
                  <template #first>
                    <b-select-option v-show="!form.breaker_box" :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>

            <StepNotes
              :value="form.electrical_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { conduitOptions, breakerOptions } from '../../../../sharedOptions/puertasAutomaticasModule'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import Label from '../Label'
import StepNotes from '../StepNotes'

export default {
  name: 'Electrical',
  components: { ConfiguratorStepTitle, ValidationObserver, ValidationProvider, Label, StepNotes },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        voltage: [],
        voltage_responsible: null,
        voltage_conduit: null,
        voltage_distance: null,
        control_wiring_responsible: null,
        control_wiring_conduit: null,
        control_wiring_distance: null,
        surge_suppressor_responsible: null,
        breaker_box: null,
        electrical_notes: ''
      },
      conduitOptions: conduitOptions,
      breakerOptions: breakerOptions
    }
  },
  mounted () {
    if (this.puerta) {
      this.form.voltage = this.puerta.voltage || []
      this.form.voltage_responsible = this.puerta.voltage_responsible
      this.form.voltage_conduit = this.puerta.voltage_conduit
      this.form.voltage_distance = this.puerta.voltage_distance
      this.form.control_wiring_responsible = this.puerta.control_wiring_responsible
      this.form.control_wiring_conduit = this.puerta.control_wiring_conduit
      this.form.control_wiring_distance = this.puerta.control_wiring_distance
      this.form.surge_suppressor_responsible = this.puerta.surge_suppressor_responsible
      this.form.breaker_box = this.puerta.breaker_box
      this.form.electrical_notes = this.puerta.electrical_notes
    }
  },
  computed: {
    ...mapState({
      puerta: state => state.configurator.configurable
    }),
    ...mapGetters(['configuratorStepNumber'])
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => {
        const puertaValue = this.puerta[key]

        if (Array.isArray(value) && Array.isArray(puertaValue)) {
          return JSON.stringify(value) !== JSON.stringify(puertaValue)
        }

        return value !== puertaValue
      })
    },
    updateStepNotes (notes) {
      this.form.electrical_notes = notes
    }
  }
}
</script>